module.exports = __webpack_public_path__ + "img/18.e7a88007.jpg";